import { Helmet } from 'react-helmet-async';
import { getFullUrl, getImageUrl } from '../utils/url';

const SEO = ({ 
  title = "MMD CONSEIL - Expert-Comptable à Lyon et Rillieux-la-Pape", 
  description = "Cabinet d'expertise comptable MMD CONSEIL à Rillieux-la-Pape. Makhan DIALLO, expert-comptable diplômé, accompagne TPE et PME : comptabilité, fiscalité, paie, conseil.",
  keywords = "expert-comptable Lyon, cabinet comptable Rillieux-la-Pape, expertise comptable, fiscal, paie, conseil entreprise, Makhan DIALLO, MMD CONSEIL",
  url,
  image = "/mmd-logo.png",
  type = "website"
}) => {
  // Générer les URLs dynamiques
  const currentUrl = url || getFullUrl();
  const imageUrl = getImageUrl(image);
  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>
      
      {/* Meta descriptions */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="MMD CONSEIL" />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={imageUrl} />
      
      {/* Données structurées pour l'entreprise */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "AccountingService",
            "name": "MMD CONSEIL",
            "image": "${imageUrl}",
            "description": "${description}",
            "url": "${currentUrl}",
            "telephone": "+33482530684",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "220 Avenue Victor Hugo",
              "addressLocality": "Rillieux-la-Pape", 
              "postalCode": "69140",
              "addressCountry": "FR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 45.8186,
              "longitude": 4.8981
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday", 
                "Wednesday",
                "Thursday",
                "Friday"
              ],
              "opens": "09:00",
              "closes": "17:00"
            },
            "founder": {
              "@type": "Person",
              "name": "Makhan DIALLO",
              "jobTitle": "Expert-Comptable Diplômé"
            },
            "areaServed": [
              "Lyon",
              "Rillieux-la-Pape",
              "Villeurbanne",
              "Caluire-et-Cuire",
              "Rhône"
            ],
            "priceRange": "€€",
            "sameAs": [
              "https://www.linkedin.com/company/mmd-conseil"
            ]
          }
        `}
      </script>
      
      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />
      
      {/* Favicon */}
      <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      
      {/* Langue */}
      <html lang="fr" />
    </Helmet>
  );
};

export default SEO;